import { QRCodeSVG } from 'qrcode.react';

export default function QrCode({ value, size = 260, className = '' }) {
  return (
    <QRCodeSVG
      value={String(value || '')}
      size={size}
      level='M'
      marginSize={4}
      bgColor='#ffffff'
      fgColor='#111111'
      className={className}
      title='Codigo QR'
    />
  );
}
